/*
* 出資者情報登録申請 - モーダル専用実装
*/
import ConsentApi from '@js/modules/consentApi/index';

export default class InvestorRegistrationModal {
  constructor() {
    this.modalId = 'investor-consent-modal';
    this.$checkConsents = document.querySelectorAll('[data-target="investorRegistrationModal"]');
    this.$checkConsentButton = document.querySelector('[data-target="checkConsentButton"]');
  }

  // モーダル専用のイベント設定
  attachEvent() {
    Array.prototype.forEach.call(this.$checkConsents, $item => {
      const url = $item.getAttribute('data-url');
      const linkTitle = $item.getAttribute('data-link-title');

      $item.addEventListener('click', (e) => {
        e.preventDefault();
        
        // チェックボックスをクリックした場合は何もしない
        if (e.target.type === 'checkbox') {
          return;
        }
        
        // モーダル表示
        this.showModal(linkTitle, url, $item);
      });
    });
    
    // 初期状態でボタンの状態を設定（InvestorRegistrationModal独自のロジックは削除予定）
    // ConsentCoordinatorが送信ボタンを制御
  }

  // モーダル表示
  showModal(title, url, agreementItem) {
    // 既存のモーダルがあれば削除
    const existing = document.getElementById(this.modalId);
    if (existing) existing.remove();

    // モーダルHTML生成
    const modalHTML = this.generateModalHTML(title, url);
    document.body.insertAdjacentHTML('beforeend', modalHTML);
    document.body.classList.add('is-modal');
    
    const modal = document.getElementById(this.modalId);
    const iframe = modal.querySelector('iframe');
    const consentButton = modal.querySelector('[data-consent="true"]');
    const consentCheckbox = modal.querySelector('[data-modal-consent="checkbox"]');
    
    // iframe読み込み完了時の処理
    iframe.addEventListener('load', () => {
      // iframe読み込み完了後もチェックボックスがチェックされていない限りボタンは無効のまま
      if (consentCheckbox.checked) {
        consentButton.disabled = false;
      }
    });

    // チェックボックス変更時の処理
    consentCheckbox.addEventListener('change', () => {
      consentButton.disabled = !consentCheckbox.checked;
    });

    // 同意ボタンクリック時の処理
    consentButton.addEventListener('click', () => {
      if (consentCheckbox.checked) {
        // 元のチェックボックスにもチェックを入れる
        const originalCheckbox = agreementItem.querySelector('input[type="checkbox"]');
        if (originalCheckbox) originalCheckbox.checked = true;

        agreementItem.classList.add('is-checked');

        // DB保存処理を追加
        this.saveConsent(agreementItem);

        // 状態変更を明示的に通知
        const linkId = agreementItem.getAttribute('data-link-id');
        document.dispatchEvent(new CustomEvent('consent:changed', {
          detail: {
            type: 'investor-modal',
            linkId: linkId,
            consented: true,
            element: agreementItem
          }
        }));

        this.closeModal(modal);
        // 送信ボタン制御はConsentCoordinatorが担当
      }
    });

    // 閉じるボタン
    modal.querySelectorAll('[data-close="modalClose"]').forEach(btn => {
      btn.addEventListener('click', () => {
        this.closeModal(modal);
      });
    });

    // オーバーレイクリックで閉じる
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        this.closeModal(modal);
      }
    });
  }


  // モーダル閉じる
  closeModal(modal) {
    modal.classList.remove('is-show');
    modal.classList.add('is-hide');
    document.body.classList.remove('is-modal');
    
    setTimeout(() => modal.remove(), 300);
  }



  // 同意状態をDBに保存（ConsentApiを使用）
  saveConsent($item) {
    const linkId = $item.getAttribute('data-link-id');
    const endpoint = $item.getAttribute('data-save-consent-endpoint');

    if (!linkId || !endpoint) return;

    ConsentApi.saveInvestorConsent(linkId, endpoint);
  }

  // 送信ボタン制御メソッドはConsentCoordinatorに移管

  // モーダルHTML生成
  generateModalHTML(title, url) {
    return `
      <div class="modal modal-overlay is-show" id="${this.modalId}">
        <div class="modal-wrap modal-wrap--large">
          <div class="modal-content panel-both">
            <button class="modal-close" type="button" data-close="modalClose" aria-label="閉じる"></button>
            
            <h2 class="modal-content__heading">${title}</h2>
            
            <div class="modal-content__scrollable">
              <iframe src="${url}" class="modal-content__iframe"></iframe>
            </div>

            <div class="modal-content__consent modal-content__consent--js-generated">
              <label class="modal-content__consent-label">
                <input type="checkbox" class="modal-content__consent-checkbox" data-modal-consent="checkbox">
                <span class="modal-content__consent-checkmark"></span>
                <span class="modal-content__consent-text">
                  上記内容を確認しました
                </span>
              </label>
            </div>

            <div class="modal-content__button modal-content__button--consent modal-content__button--consent--js-generated">
              <button type="button" class="button-base--sub" data-close="modalClose">
                閉じる
              </button>
              <button type="button" class="button-base--action" data-consent="true" disabled>
                同意する
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
